import { PeriodUnit } from 'components/CustomRepeatEvery/CustomRepeatEvery';
import { translate } from 'components/Translation';
import { paymentType, serviceType } from 'utils/api/models/topUpAddons/singleSubscription';

let period = '';
const everyString = translate('every');

export const getServiceType = (st: serviceType) => {
	if (st) {
		if (serviceType[st].toString() === serviceType.TOP_UP.toString()) {
			return translate('top.up.add.ons.top.up');
		} else if (serviceType[st].toString() === serviceType.ADD_ONS.toString()) {
			return translate('top.up.add.ons.add.ons');
		} else {
			return translate('services');
		}
	}
};

export const getPaymentType = (pt: paymentType) => {
	if (paymentType[pt].toString() === paymentType.MASTER_NUMBER.toString()) {
		return translate('prepaid.loyalty.add.new.services.master.number');
	}
	return translate('prepaid.loyalty.add.new.services.credit.card');
};

export const getRecurrence = (recurrence: string) => {
	if (recurrence === 'ONE_TIME') {
		return translate('usage.one.time');
	} else {
		const rgx = new RegExp(/[^\d]+|\d+/g);
		const tokens = recurrence.match(rgx);

		if (tokens?.length) {
			const count = Number(tokens[0]);
			const addS = count > 1 ? 's' : '';
			if (tokens[1] === 'D') {
				period = translate(`custom.repeat.every.day${addS}`);
			} else if (tokens[1] === 'W') {
				period = translate(`custom.repeat.every.week${addS}`);
			} else if (tokens[1] === 'M') {
				period = translate(`custom.repeat.every.month${addS}`);
			} else if (tokens[1] === 'Y') {
				period = translate(`custom.repeat.every.year${addS}`);
			}
			return everyString + String(count) + ' ' + period;
		}
		return null;
	}
};

export const getRecurrenceSummaryTab = (periodicity: string, selectedPeriod: PeriodUnit) => {
	const addS = Number(periodicity) > 1 ? 's' : '';
	if (selectedPeriod === PeriodUnit.DAY) {
		period = translate(`custom.repeat.every.day${addS}`);
	} else if (selectedPeriod === PeriodUnit.WEEK) {
		period = translate(`custom.repeat.every.week${addS}`);
	} else if (selectedPeriod === PeriodUnit.MONTH) {
		period = translate(`custom.repeat.every.month${addS}`);
	} else if (selectedPeriod === PeriodUnit.YEAR) {
		period = translate(`custom.repeat.every.year${addS}`);
	}
	return everyString + periodicity + ' ' + period;
};
